import { Col, Form, Row, Typography } from "antd";
import GeneralComplaintReason from "apps/Common/ComplaintReasones/GeneralComplaintReasonInput";
import { MazakaForm } from "apps/Common/MazakaForm";
import { MazakaTextArea } from "apps/Common/MazakaTextarea";
import useMazakaForm from "hooks/useMazakaForm";
import { FC, } from "react";
import { complaintByUser } from "../../Services";
import { RootState } from "store/Reducers";
import { useSelector } from "react-redux";
import { openNotificationWithIcon } from "helpers/OpenNotificationWithIcon";

interface ReportUserProps {
  onFinish: any;
}
const ReportUser: FC<ReportUserProps> = ({ onFinish }) => {
  const [form] = Form.useForm();
  const { formActions, mazakaForm } = useMazakaForm(form);
 const {userInfoes} = useSelector((state:RootState)=>state.profile)
 const {messageDetilsFilter} = useSelector((state:RootState)=>state.message)
  const { Text } = Typography;
  const handleOnFinish = async () => {
    mazakaForm.setLoading();
    let formValues = form.getFieldsValue()
    formValues["description"] = formValues["description"]||""
    formValues["advertId"] = messageDetilsFilter?.AdvertId
    formValues["complainerUserId"]=userInfoes.id
    formValues["reportedUserId"]=messageDetilsFilter?.ContactUserId

    try {

        await complaintByUser(formValues)
        mazakaForm.setSuccess(2000,()=>"İşlem Başarılı")
        openNotificationWithIcon("default","Şikayetiniz başarıyla gönderildi")
        form.resetFields()
        onFinish()
    } catch (error:any) {
        mazakaForm.setFailed(2000,error?.message)
       console.log("Somethings wrogn during compalint by user",error) 
    }
  };
  return (
    <>
      <Col xs={24}>
        <MazakaForm
          onFinish={handleOnFinish}
          form={form}
          submitButtonXPosition="left"
          {...formActions}
        >
          <Row>
            <Col xs={24} className="!flex justify-center">
              <Text className="!text-2xl !font-bold !text-black">
                Şikayet Et
              </Text>
            </Col>
            <GeneralComplaintReason
              xs={24}
              label="Şikayet Nedeniniz"
              placeholder="Şikayet Nedeniniz"
              name={"complaintBlockReasonId"}
              rules={[{ required: true, message: "" }]}
            />
            <MazakaTextArea name="description" label={"Açıklama"} placeholder="Açıklama" />
          </Row>
        </MazakaForm>
      </Col>
    </>
  );
};

export default ReportUser;
